export const environment = {
  production: false,
  apiUrl: 'https://hb-2930-api.dottesting.com',
  cognito: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_t6z3VWKgj',
    clientId: '1hh1l8n3l8bsqnm4cg5vcpq2mj',
  },
  firebase: {
    apiKey: "AIzaSyBLuS94qlrmsBs8tjyrZW4Yi2GmqnRnQns",
    authDomain: "hb-cash-management.firebaseapp.com",
    projectId: "hb-cash-management",
    storageBucket: "hb-cash-management.firebasestorage.app",
    messagingSenderId: "268265018799",
    appId: "1:268265018799:web:46eeb9757f4af5d1a28b5a",
    measurementId: "G-68T48YN9WS",
    vapidKey: 'BLXal5_AwMeHq82Ni-o2773CS2gppLlLDiiPm-gst4NLc9BHQFJt5Si0acLmKVqR5Xxp1yIGjXcpzLCbNJCEiiI'
  }
};
